import { Injectable } from '@angular/core';
import { HttpService } from '../../shared/http/base.http';

export interface EmailRequestModel {
   ToEmail: string;
   Subject: string;
   ReplyToEmail: string;
   PlainContent: string;
   HtmlContent: string;
   CcEmails?: string;
   BccEmails: string;
   FromName?: string;
}

@Injectable({ providedIn: 'root' })
export class FormsApiService extends HttpService {
   sendEmail(request: EmailRequestModel) {
      return this.post('/email/sendemail', request);
   }
}
